// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"C_thecomp__56_2g","loop":"C_loop__5eIZH"};